import PasswordValidator from 'password-validator';

export const PASSWORD_MIN_LENGTH = 14;
export const PASSWORD_REPEATED_CHARS_LIMIT = 3;

const REPEATED_CHARS_REGEX = new RegExp(`(.)\\1{${PASSWORD_REPEATED_CHARS_LIMIT - 1},}`, 'i');

const validator = new PasswordValidator();
validator.is().min(PASSWORD_MIN_LENGTH).has().uppercase().has().lowercase().has().digits(2).has().symbols()
    .usingPlugin((password: string) => !REPEATED_CHARS_REGEX.test(password));

export function getPasswordRequirements(password: string) {
    const missing = validator.validate(password, { list: true }) as string[];

    return {
        hasMinLength: !missing.includes('min'),
        hasDigits: !missing.includes('digits'),
        hasUppercase: !missing.includes('uppercase'),
        hasLowercase: !missing.includes('lowercase'),
        hasSymbols: !missing.includes('symbols'),
        hasNoRepeatedChars: !missing.includes('usingPlugin'),
        isValid: missing.length === 0,
    };
}
